package com.nonopn.skydome.common.app.pages.main.model

import com.nonopn.skywatcher.maps.LatLng
import kotlinx.serialization.Serializable

@Serializable
enum class DocumentHistoryType {
    KERAUNIC_REPORT,
    CERT_NSG,
    CERT_LIGHTNING
}

@Serializable
data class DocumentHistoryItem(
    val id: String = "",
    val type: DocumentHistoryType = DocumentHistoryType.KERAUNIC_REPORT,
    val siteName: String = "",
    val latitude: Double? = null,
    val longitude: Double? = null,
    val createdAtSecondsUtc: Long = 0L,
    // Impact-specific fields for lightning certificate re-navigation
    val impactLat: Double? = null,
    val impactLon: Double? = null,
    val impactTimestamp: Long = 0L,
    val impactAmplitude: Int = 0,
    val impactPercent: Double = 0.0,
    val impactExternalId: String = "",
)

@Serializable
data class SpecificData(
    val zoom: Double? = null,
    val coordinates: LatLng? = null,
    val documentHistory: List<DocumentHistoryItem> = emptyList(),
    // Display preference only (never a right): the administrator mode is restored at startup only when
    // the server confirmed an admin account for the session
    val adminModePreferred: Boolean = false,
)
